import React from "react";
import { Icon, Stack, Popover, Button } from "@bookingcom/bui-react";
import { LighthouseIcon } from "@bookingcom/bui-assets-react/streamline";
const RankingXray = ({ rankingXray }) => {
    return (React.createElement(Stack, { alignItems: "end" },
        React.createElement(Popover, { triggerType: "hover", hideClose: true, size: "stretch", position: "bottom-end" },
            React.createElement(Popover.Trigger, null, (attributes) => {
                return (React.createElement(Button, { variant: "secondary-neutral", attributes: attributes },
                    React.createElement(Icon, { svg: LighthouseIcon, size: "larger" })));
            }),
            React.createElement(Popover.Content, null,
                React.createElement("pre", null,
                    "Ranking X-ray:",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    JSON.stringify(rankingXray, null, 2))))));
};
export { RankingXray };
